export default "__VITE_ASSET__5edc8cf8__"